/** "Checks: unchanged from v1" / "Checks: changed from v1; …" over a tab. */
export function ChangeNote({
  section,
  changed,
  compareLabel,
  changedText
}: {
  section: string
  changed: boolean
  compareLabel: string
  changedText?: string
}) {
  return (
    <p
      className="text-11 text-ink-3"
      data-testid={`change-note-${section.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {section}:{' '}
      {changed ? (
        <span className="text-st-warn">
          changed from {compareLabel}
          {changedText ? `; ${changedText}` : ''}
        </span>
      ) : (
        <span>unchanged from {compareLabel}</span>
      )}
    </p>
  )
}
